'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _About = require('../modules/about/action/About');

var _About2 = _interopRequireDefault(_About);

var _New = require('../modules/start/action/New');

var _New2 = _interopRequireDefault(_New);

var _Offline = require('../modules/start/action/Offline');

var _Offline2 = _interopRequireDefault(_Offline);

var _Search = require('../modules/search/action/Search');

var _Search2 = _interopRequireDefault(_Search);

var _Start = require('../modules/start/action/Start');

var _Start2 = _interopRequireDefault(_Start);

var _ReportPeople = require('../modules/report/action/ReportPeople');

var _ReportPeople2 = _interopRequireDefault(_ReportPeople);

var _Import = require('../modules/import/action/Import');

var _Import2 = _interopRequireDefault(_Import);

var _Export = require('../modules/export/action/Export');

var _Export2 = _interopRequireDefault(_Export);

var _EditPerson = require('../modules/person/action/EditPerson');

var _EditPerson2 = _interopRequireDefault(_EditPerson);

var _EditPosition = require('../modules/position/action/EditPosition');

var _EditPosition2 = _interopRequireDefault(_EditPosition);

var _EditEducation = require('../modules/education/action/EditEducation');

var _EditEducation2 = _interopRequireDefault(_EditEducation);

var _EditOrganisation = require('../modules/organisation/action/EditOrganisation');

var _EditOrganisation2 = _interopRequireDefault(_EditOrganisation);

var _EditLocation = require('../modules/location/action/EditLocation');

var _EditLocation2 = _interopRequireDefault(_EditLocation);

var _EditLogentry = require('../modules/logentry/action/EditLogentry');

var _EditLogentry2 = _interopRequireDefault(_EditLogentry);

var _EditRelationship = require('../modules/relationship/action/EditRelationship');

var _EditRelationship2 = _interopRequireDefault(_EditRelationship);

var _EditFile = require('../modules/file/action/EditFile');

var _EditFile2 = _interopRequireDefault(_EditFile);

var _EnterCredentials = require('../modules/start/action/EnterCredentials');

var _EnterCredentials2 = _interopRequireDefault(_EnterCredentials);

var _ChangeCredentials = require('../modules/start/action/ChangeCredentials');

var _ChangeCredentials2 = _interopRequireDefault(_ChangeCredentials);

var _Welcome = require('../modules/start/action/Welcome');

var _Welcome2 = _interopRequireDefault(_Welcome);

var _Sync = require('../modules/start/action/Sync');

var _Sync2 = _interopRequireDefault(_Sync);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NavigationManager = function () {
  function NavigationManager(element) {
    _classCallCheck(this, NavigationManager);

    this.element = element;
    addEventListener('popstate', this.handleNavigation.bind(this));
  }

  _createClass(NavigationManager, [{
    key: 'handleNavigation',
    value: function handleNavigation() {
      window.PRIM.cancelDelayedNavigation();

      var path = location.hash.split('/');

      if (path.length < 2) {
        return;
      }

      this.element.innerHTML = '';

      // split on '/'
      switch (path[1]) {
        case 'sync':
          new _Sync2.default(this.element);
          break;
        case 'people':
          new _EditPerson2.default(this.element, { id: path.length > 2 ? path[2] : undefined });
          break;
        case 'files':
          new _EditFile2.default(this.element, { id: path.length > 2 ? path[2] : undefined });
          break;
        case 'positions':
          new _EditPosition2.default(this.element, {
            id: path.length === 3 ? path[2] : undefined,
            person_id: path.length > 3 && path[2] === 'person' ? path[3] : undefined,
            location_id: path.length > 3 && path[2] === 'location' ? path[3] : undefined
          });
          break;
        case 'educations':
          new _EditEducation2.default(this.element, {
            id: path.length === 3 ? path[2] : undefined,
            location_id: path.length > 3 ? path[3] : undefined
          });
          break;
        case 'organisations':
          new _EditOrganisation2.default(this.element, { id: path.length > 2 ? path[2] : undefined });
          break;
        case 'locations':
          new _EditLocation2.default(this.element, {
            id: path.length === 3 ? path[2] : undefined,
            organisation_id: path.length > 3 ? path[3] : undefined
          });
          break;
        case 'logentries':
          new _EditLogentry2.default(this.element, {
            id: path.length === 3 ? path[2] : undefined,
            object_type: path.length > 3 ? path[2] : undefined,
            target_id: path.length > 3 ? path[3] : undefined
          });
          break;
        case 'relationships':
          new _EditRelationship2.default(this.element, {
            id: path.length === 3 ? path[2] : undefined,
            person_id: path.length > 3 ? path[3] : undefined
          });
          break;
        case 'about':
          new _About2.default(this.element);
          break;
        case 'reportpeople':
          new _ReportPeople2.default(this.element);
          break;
        case 'import':
          new _Import2.default(this.element);
          break;
        case 'export':
          new _Export2.default(this.element);
          break;
        case 'entercredentials':
          new _EnterCredentials2.default(this.element);
          break;
        case 'changecredentials':
          new _ChangeCredentials2.default(this.element);
          break;
        case 'offline':
          new _Offline2.default(this.element);
          break;
        case 'start':
          new _Start2.default(this.element);
          break;
        case 'new':
          new _New2.default(this.element);
          break;
        case 'search':
          new _Search2.default(this.element);
          break;
        default:
          new _EnterCredentials2.default(this.element);
          break;
      }
    }
  }]);

  return NavigationManager;
}();

exports.default = NavigationManager;


//////////////////
// WEBPACK FOOTER
// ./js/lib/NavigationManager.js
// module id = 15
// module chunks = 0